function initLocationsMap() {
    if (typeof google === 'undefined' || !google.maps) {
        setTimeout(initLocationsMap, 100);
        return;
    }

    var locations = JSON.parse(window.FZWL_Locations);
    var bounds = new google.maps.LatLngBounds();
    var currentInfoWindow = null;

    var mapStyles = [
        {
            elementType: 'geometry',
            stylers: [{ color: '#212D39' }]
        },
        {
            elementType: 'labels.text.fill',
            stylers: [{ color: '#8a9aa8' }]
        },
        {
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#212D39' }]
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{ color: '#1a2530' }]
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#2a3642' }]
        },
        {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#1a2530' }]
        },
        {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
        },
        {
            featureType: 'transit',
            stylers: [{ visibility: 'off' }]
        },
        {
            featureType: 'transit.station',
            stylers: [{ visibility: 'off' }]
        },
        {
            featureType: 'transit.line',
            stylers: [{ visibility: 'off' }]
        }
    ];

    var map = new google.maps.Map(document.getElementById('map-canvas'), {
        zoom: 13,
        center: {lat: 45.8150, lng: 15.9819},
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        rotateControl: false,
        scaleControl: false,
        keyboardShortcuts: false,
        gestureHandling: 'greedy',
        maxZoom: 16,
        styles: mapStyles,
        padding: {top: 100, right: 50, bottom: 50, left: 50}
    });

    locations.forEach(function(location) {
        var position = {lat: parseFloat(location.lat), lng: parseFloat(location.lng)};

        // Create custom marker with white background
        var markerIcon = {
            url: window.FZWL_Favicon,
            scaledSize: new google.maps.Size(27.95, 47.45),
            anchor: new google.maps.Point(13.975, 47.45)
        };

        var marker = new google.maps.Marker({
            position: position,
            map: map,
            title: location.title,
            icon: markerIcon
        });

        var content = '<div style="padding:5px;">' +
                      '<h3 style="margin:0 0 8px 0;font-size:15px;font-weight:bold;color:#333;">' + location.title + '</h3>' +
                      '<p style="margin:0; color:#666; font-size:13px; line-height: 20px;">' + location.address + '</p>' +
                      (location.phone ? '<p style="margin:4px 0 0 0; color:#666;font-size:13px; line-height: 20px;">Tel: ' + location.phone + '</p>' : '') +
                      '</div>';

        var infoWindow = new google.maps.InfoWindow({
            content: content
        });

        marker.addListener('mouseover', function() {
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }
            infoWindow.open(map, marker);
            currentInfoWindow = infoWindow;
        });

        marker.addListener('mouseout', function() {
            infoWindow.close();
        });

        bounds.extend(position);
    });

    map.fitBounds(bounds);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocationsMap);
} else {
    initLocationsMap();
}